var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: {
        form: _vm.form,
        rules: _vm.rules,
        "label-width": "135px",
        width: "61.8%",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "div",
        { staticClass: "flex-spacebetween" },
        [
          _c(
            "el-col",
            { attrs: { span: 11 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("goodsClassify.common.ClassificationName"),
                    prop: "name",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("chooseText"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 11 } },
            [
              _c("BjFormItemCode", {
                attrs: {
                  readonly: _vm.isEdit,
                  label: _vm.$t("goodsClassify.common.ClassificationCode"),
                  placeholder: _vm.$t("goodsClassify.dialog.lettersNumbers"),
                  prop: "code",
                  validator: _vm.validatorGoodsClassifyCode,
                },
                model: {
                  value: _vm.form.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "code", $$v)
                  },
                  expression: "form.code",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex-spacebetween" },
        [
          _c(
            "el-col",
            { attrs: { span: 11 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("goodsClassify.dialog.ParentClassification"),
                    prop: "parentId",
                  },
                },
                [
                  _vm.isBjGoodsTypeTreeSelectVisible
                    ? _c("BjGoodsTypeTreeSelect", {
                        attrs: {
                          query: { statusFlag: true, subFlag: false },
                          "has-root": "",
                          disabled: _vm.isEdit,
                        },
                        model: {
                          value: _vm.form.parentId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "parentId", $$v)
                          },
                          expression: "form.parentId",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 11 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { prop: "subFlag" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("goodsClassify.dialog.LeafNode")) +
                              " "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                placement: "top-start",
                                content: _vm.$t(
                                  "goodsClassify.dialog.WhenLeafNode"
                                ),
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.form.subFlag,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "subFlag", $$v)
                      },
                      expression: "form.subFlag",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 20 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("goodsClassify.dialog.Remarks"),
                prop: "remark",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("GoodsAttributeList", {
        ref: "GoodsAttribute",
        attrs: { "parent-id": _vm.form.parentId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }